<template>
  <div class="relative right-0 h-content-window bg-black p-0.5">
    <iframe
      src="https://www.youtube.com/embed/RdZ7EyGyiLo?autoplay=1"
      class="w-full h-full"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    />
  </div>
</template>

<script setup></script>
